import { Component, HostBinding, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

//Servicios
import { UserServices } from "./services/user.service";
import { ContactComponent } from './components/ui/contact/contact.component';

//FBPixel
import { Angulartics2Facebook } from 'angulartics2/facebook';
import { Utils } from './services/utils';
import { FpServices } from './services/fp.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

    public user_snapshot;
    public showFixType = false;

    constructor( 
        public _userAPI : UserServices, 
        public router: Router, 
        private fbPixel: Angulartics2Facebook, 
        private _utils: Utils,
        private _fp: FpServices,
        private dialog: MatDialog
    ){}

    //On every app load
    ngOnInit(){

        this.fbPixel.startTracking();

        this.router.events.subscribe(event=>{
            if(event instanceof NavigationEnd){
                this._utils.reloadTawkTo();
            }
        })

        //Check session
        if(this._userAPI.isLogged()){
            this._userAPI.loadUser()
            .then(user=>{

                this._fp.onAppLoad();

                //Check Ban
                if(user['hard_ban']){
                    //Log Out
                    this.logout();
                    return;
                }

                //Check Type
                if(user['type'] == 'both' && !user['admin']) this.showFixType = true;

                this.user_snapshot = user;
            })
        }
    }

    openContactDialog() {
        this.dialog.open(ContactComponent, {
            width: '500px',
            maxHeight: '90vh'
        });
    }

    isLogged(){
    if(this._userAPI.sharedUser){
      this.user_snapshot = this._userAPI.sharedUser;
      return true;
    }
    return false;
  }

  logout(){
    this.user_snapshot = null;
    this._userAPI.logout();
    this.router.navigate(['/es/login']);
  }

  @HostBinding('class.show-fix-type')
  get showFixTypeClass() {
    return this.showFixType;
  }

  public fixType(isCompany : Boolean){
    this._userAPI.update({type: isCompany ? 'company' : 'publisher'}).toPromise()
    .then(response=>{
        this._utils.showSuccess('Registro completado. Vamos a recargar el panel...');
        //Reload
        setTimeout(()=> window.location.reload(), 2000);
    })
    .catch(error=>{
        this._utils.showError('Error al completar el registro. Contacte con soporte.');
    })
  }

}
